import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import MultiSelectCheckbox from "../../components/MultiSelectCheckbox.js";
import Select from "react-select";

const SchemeMasterDetailsDesign = () => {
  const allowAlphabets = (v) => v.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (v) => v.replace(/[^0-9]/g, "");
  const navigate = useNavigate();
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [SchemeName, setSchemeName] = useState("");
  const [ConsumerSupport, setConsumerSupport] = useState("");
  const [CompanyShare, setCompanyShare] = useState("");
  const [DealerShare, setDealerShare] = useState("");
  const [Fuel, setFuel] = useState("");
  const [Year, setYear] = useState("");
  const [ModelName, setModelName] = useState("");
  const [SchemeType, setSchemeType] = useState("");
  const [VariantName, setVariantName] = useState([]);
  const [FuelList, setFuelList] = useState([]);
  const [VariantList, setVariantList] = useState([]);
  const YearList = [];
  const [ModelNameList, setModelNameList] = useState([]);
  const SchemeTypeList = [];
  const [isEditing, setIsEditing] = useState(false);
  const routerLocation = useLocation();
  const [ipAddress, setIpAddress] = useState("");
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      height: "40px",
      borderRadius: "5px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "14px",
    }),

    valueContainer: (base) => ({
      ...base,
      height: "40px",
      padding: "0 10px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "40px",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  const fuelOptions = FuelList.map((x) => ({
    label: x.label,
    value: x.value,
  }));

  const modelOptions = ModelNameList.map((x) => ({
    label: x.label,
    value: x.value,
  }));

  const yearOptions = [
    { label: "2021", value: "2021" },
    { label: "2022", value: "2022" },
    { label: "2023", value: "2023" },
    { label: "2024", value: "2024" },
    { label: "2025", value: "2025" },
  ];

  const schemeTypeOptions = [
    { label: "Additional", value: "Additional" },
    { label: "Consumer", value: "Consumer" },
    { label: "Corporate", value: "Corporate" },
    { label: "Dealer", value: "Dealer" },
    { label: "Exchange", value: "Exchange" },
    { label: "Manufacturer", value: "Manufacturer" },
  ];

  const getSupportLabel = () => {
    switch (SchemeType) {
      case "Consumer":
        return "Consumer Support";
      case "Corporate":
        return "Corporate Support";
      case "Exchange":
        return "Exchange Amount";
      case "Additional":
        return "Additional Discount";
      case "Manufacturer":
        return "Manufacturer Support";
      case "Dealer":
        return "Dealer Discount";
      default:
        return "Support";
    }
  };

  useEffect(() => {
    fetchFuelList();
    fetchModelList();
  }, []);

  useEffect(() => {
    if (ModelName) {
      fetchVariantList();
    }
  }, [ModelName]);

  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  const fetchVariantList = async () => {
    try {
      const response = await apiFetch(
        "/api/retail/variant",
        { method: "POST", body: JSON.stringify({ modelId: ModelName, fuel: Fuel }) },
      );
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setVariantList(data);
      }
    } catch (error) {
      console.error("❌ Error fetching variant list:", error);
    }
  };

  const fetchFuelList = async () => {
    try {
      const response = await apiFetch(
        "/api/retail/fuel",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setFuelList(data);
      }
    } catch (error) {
      console.error("❌ Error fetching fuel list:", error);
    }
  };

  const fetchModelList = async () => {
    try {
      const response = await apiFetch(
        "/api/retail/model",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      console.log("MODEL API RESPONSE:", data);
      if (data && Array.isArray(data)) {
        setModelNameList(data);
      }
    } catch (error) {
      console.error("❌ Error fetching model list:", error);
    }
  };

  const handleExit = () => {
    navigate("/SchemeMasterGrid");
  };

  useEffect(() => {
    setGridRows((prev) =>
      prev.map((row) => {
        let x = { ...row };
        x.ConsumerSupport = "0";
        x.CompanyShare = "0";
        x.DealerShare = "0";
        x.ExchangeAmount = "0";
        x.CompanyShareX = "0";
        x.DealerShareX = "0";
        x.CorporateAmount = "0";
        x.CompanyShareC = "0";
        x.DealerShareC = "0";
        x.MfgYearAmount = "0";
        x.CompanyShareM = "0";
        x.DealerShareM = "0";
        x.DealerDiscountAmount = "0";
        x.CompanyShareD = "0";
        x.DealerShareD = "0";
        x.AdditionalDiscountAmount = "0";
        x.CompanyShareA = "0";
        x.DealerShareA = "0";
        console.log(SchemeType);
        switch (SchemeType) {
          case "Consumer":
            x.ConsumerSupport = ConsumerSupport || "0";
            x.CompanyShare = CompanyShare || "0";
            x.DealerShare = DealerShare || "0";
            break;
          case "Corporate":
            x.CorporateAmount = ConsumerSupport || "0";
            x.CompanyShareC = CompanyShare || "0";
            x.DealerShareC = DealerShare || "0";
            break;
          case "Exchange":
            x.ExchangeAmount = ConsumerSupport || "0";
            x.CompanyShareX = CompanyShare || "0";
            x.DealerShareX = DealerShare || "0";
            break;
          case "Manufacturer":
            x.MfgYearAmount = ConsumerSupport || "0";
            x.CompanyShareM = CompanyShare || "0";
            x.DealerShareM = DealerShare || "0";
            break;
          case "Dealer":
            x.DealerDiscountAmount = ConsumerSupport || "0";
            x.CompanyShareD = CompanyShare || "0";
            x.DealerShareD = DealerShare || "0";
            break;
          case "Additional":
            x.AdditionalDiscountAmount = ConsumerSupport || "0";
            x.CompanyShareA = CompanyShare || "0";
            x.DealerShareA = DealerShare || "0";
            break;
          default:
            break;
        }
        return x;
      }),
    );
  }, [SchemeType, ConsumerSupport, CompanyShare, DealerShare]);

  const [gridRows, setGridRows] = useState([]);
  const loadGridData = async (variantList) => {
    const response = await apiFetch(
      "/api/retail/filterloader",
      {
        method: "POST",
        body: JSON.stringify({
          modelId: ModelName,
          fuel: Fuel,
          variant: variantList.join(","),
        }),
      },
    );
    const data = await response.json();
    const rows = data.map((r) => {
      let x = {
        unq: r.varunq || "",
        modelunq: r.modelunq || "",
        varunq: r.varunq || "",
        variant: r.Variant,
        Fsc: r.fsc || "0",
        VIN: r.Vin,
        fuel: r.fuel,
        ConsumerSupport: "0",
        CompanyShare: "0",
        DealerShare: "0",
        ExchangeAmount: "0",
        CompanyShareX: "0",
        DealerShareX: "0",
        CorporateAmount: "0",
        CompanyShareC: "0",
        DealerShareC: "0",
        MfgYearAmount: "0",
        CompanyShareM: "0",
        DealerShareM: "0",
        DealerDiscountAmount: "0",
        CompanyShareD: "0",
        DealerShareD: "0",
        AdditionalDiscountAmount: "0",
        CompanyShareA: "0",
        DealerShareA: "0",
      };

      console.log(SchemeType);

      switch (SchemeType) {
        case "Consumer":
          x.ConsumerSupport = ConsumerSupport || "0";
          x.CompanyShare = CompanyShare || "0";
          x.DealerShare = DealerShare || "0";
          break;
        case "Corporate":
          x.CorporateAmount = ConsumerSupport || "0";
          x.CompanyShareC = CompanyShare || "0";
          x.DealerShareC = DealerShare || "0";
          break;
        case "Exchange":
          x.ExchangeAmount = ConsumerSupport || "0";
          x.CompanyShareX = CompanyShare || "0";
          x.DealerShareX = DealerShare || "0";
          break;
        case "Manufacturer":
          x.MfgYearAmount = ConsumerSupport || "0";
          x.CompanyShareM = CompanyShare || "0";
          x.DealerShareM = DealerShare || "0";
          break;
        case "Dealer":
          x.DealerDiscountAmount = ConsumerSupport || "0";
          x.CompanyShareD = CompanyShare || "0";
          x.DealerShareD = DealerShare || "0";
          break;
        case "Additional":
          x.AdditionalDiscountAmount = ConsumerSupport || "0";
          x.CompanyShareA = CompanyShare || "0";
          x.DealerShareA = DealerShare || "0";
          break;
        default:
          break;
      }
      return x;
    });
    console.log("API rows:", rows);
    setGridRows(rows);
  };

  const handleGridChange = (index, field, value) => {
    const updated = [...gridRows];
    updated[index][field] = value;
    setGridRows(updated);
  };
  const handleSave = async () => {
    try {
      const mainPayload = {
        FromDate,
        ToDate,
        SchemeName,
        Fuel,
        Year,
        ModelName,
        SchemeType,
        ConsumerSupport,
        CompanyShare,
        DealerShare,
        userId: storedUserInfo.userId,
        ipAddress: ipAddress,
        serverIp: window.location.hostname,
        //  ipAddress: "0.0.0.0",
        // serverIp: "127.0.0.1",
      };
      const mainResponse = await apiFetch(
        "/api/retail/saveMain",
        { method: "POST", body: JSON.stringify(mainPayload) },
      );
      const mainRes = await mainResponse.json();
      const unqid = mainRes.unqid;
      console.log("MAIN-SAVED UUID:", unqid);
      const childPayload = {
        mainUnqid: unqid,
        rows: gridRows,
        ModelName,
      };
      await apiFetch(
        "/api/retail/saveChild",
        { method: "POST", body: JSON.stringify(childPayload) },
      );
      alert("Saved Successfully!");
      navigate("/SchemeMasterGrid");
    } catch (err) {
      console.error("SAVE ERROR:", err);
      alert("Error saving data!");
    }
  };

  useEffect(() => {
    const editData = routerLocation.state?.editData;
    if (!editData) return;
    setIsEditing(true);
    const all = editData;
    const main = all[0];
    const firstChild = all[1];
    setFromDate(main.sp_549 || "");
    setToDate(main.sp_550 || "");
    setSchemeName(main.schemename || "");
    setFuel(main.fuel || "");
    setYear(main.year || "");
    setModelName(main.model || "");
    setSchemeType(main.schemetype || "");

    if (firstChild) {
      const st = main.schemetype;
      const mapping = {
        Consumer: {
          amt: firstChild.rs,
          comp: firstChild.RSCS,
          dealer: firstChild.RSDS,
        },
        Corporate: {
          amt: firstChild.cr,
          comp: firstChild.CACS,
          dealer: firstChild.CSDS,
        },
        Exchange: {
          amt: firstChild.ec,
          comp: firstChild.EXACS,
          dealer: firstChild.EXADS,
        },
        Manufacturer: {
          amt: firstChild.mfg,
          comp: firstChild.MFGCS,
          dealer: firstChild.MFGDS,
        },
        Dealer: {
          amt: firstChild.dis,
          comp: firstChild.DDACS,
          dealer: firstChild.DDADS,
        },
        Additional: {
          amt: firstChild.loyality,
          comp: firstChild.cloyality,
          dealer: firstChild.dloyality,
        },
      };
      if (mapping[st]) {
        setConsumerSupport(mapping[st].amt || "");
        setCompanyShare(mapping[st].comp || "");
        setDealerShare(mapping[st].dealer || "");
      }
    }

    const childRows = all.slice(1).map((c) => ({
      unq: c.cunq ?? "",
      modelunq: c.modelunq ?? "",
      varunq: c.varunq ?? "",
      variant: c.Variant ?? "",
      Fsc: c.Fsc ?? "",
      VIN: c.VIN ?? "",
      fuel: c.fuelc ?? "",
      ConsumerSupport: c.rs ?? "",
      CompanyShare: c.RSCS ?? "",
      DealerShare: c.RSDS ?? "",
      ExchangeAmount: c.ec ?? "",
      CompanyShareX: c.EXACS ?? "",
      DealerShareX: c.EXADS ?? "",
      CorporateAmount: c.cr ?? "",
      CompanyShareC: c.CACS ?? "",
      DealerShareC: c.CSDS ?? "",
      MfgYearAmount: c.mfg ?? "",
      CompanyShareM: c.MFGCS ?? "",
      DealerShareM: c.MFGDS ?? "",
      DealerDiscountAmount: c.dis ?? "",
      CompanyShareD: c.DDACS ?? "",
      DealerShareD: c.DDADS ?? "",
      AdditionalDiscountAmount: c.loyality ?? "",
      CompanyShareA: c.cloyality ?? "",
      DealerShareA: c.dloyality ?? "",
    }));

    setGridRows(childRows);
    const selectedVariants = childRows.map((r) => r.varunq);

    setTimeout(() => {
      setVariantName(selectedVariants);
    }, 200);
  }, [routerLocation.state]);

  const handleUpdate = async () => {
    try {
      const mainPayload = {
        unqid: routerLocation.state.editData[0].unq,
        FromDate,
        ToDate,
        SchemeName,
        Fuel,
        Year,
        ModelName,
        SchemeType,
      };
      console.log(mainPayload);
      await apiFetch(
        "/api/retail/updateMain",
        { method: "POST", body: JSON.stringify(mainPayload) },
      );

      const childPayload = {
        mainUnqid: mainPayload.unqid,
        rows: gridRows,
      };

      await apiFetch(
        "/api/retail/updateChild",
        { method: "POST", body: JSON.stringify(childPayload) },
      );
      console.log(childPayload);
      alert("Updated Successfully!");
      navigate("/SchemeMasterGrid");
    } catch (err) {
      console.error("UPDATE ERROR:", err);
      alert("Error updating data!");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Scheme Support</div>

          {/* ---------------- FORM ROW 1 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>EFFECTIVE DATE</label>
              <input
                type="date"
                value={FromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            <div className="form-column">
              <label>TO DATE</label>
              <input
                type="date"
                value={ToDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            <div className="form-column">
              <label>Scheme Name</label>
              <input
                type="text"
                value={SchemeName}
                onChange={(e) => setSchemeName(allowAlphabets(e.target.value))}
              />
            </div>

            <div className="form-column">
              <label>Fuel</label>
              <Select
                options={fuelOptions}
                value={fuelOptions.find((o) => o.value === Fuel) || null}
                onChange={(s) => setFuel(s?.value || "")}
                styles={customSelectStyles}
                placeholder="Select Fuel"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
          </div>

          {/* ---------------- FORM ROW 2 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Year</label>
              <Select
                options={yearOptions}
                value={yearOptions.find((o) => o.value === Year) || null}
                onChange={(s) => setYear(s?.value || "")}
                styles={customSelectStyles}
                placeholder="Select Year"
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-column">
              <label>Model Name</label>
              <Select
                options={modelOptions}
                value={modelOptions.find((o) => o.value === ModelName) || null}
                onChange={(s) => setModelName(s?.value || "")}
                styles={customSelectStyles}
                placeholder="Select Model"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-column">
              <label>Scheme Type</label>
              <Select
                options={schemeTypeOptions}
                value={
                  schemeTypeOptions.find((o) => o.value === SchemeType) || null
                }
                onChange={(s) => setSchemeType(s?.value || "")}
                styles={customSelectStyles}
                placeholder="Select Scheme Type"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-column">
              <label>{getSupportLabel()}</label>
              <input
                type="number"
                value={ConsumerSupport}
                onChange={(e) =>
                  setConsumerSupport(allowNumbers(e.target.value))
                }
              />
            </div>
          </div>

          {/* ---------------- FORM ROW 3 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Company Share</label>
              <input
                type="number"
                value={CompanyShare}
                onChange={(e) => setCompanyShare(allowNumbers(e.target.value))}
              />
            </div>

            <div className="form-column">
              <label>Dealer Share</label>
              <input
                type="number"
                value={DealerShare}
                onChange={(e) => setDealerShare(allowNumbers(e.target.value))}
              />
            </div>

            <div className="form-column">
              <label>Variant</label>
              <MultiSelectCheckbox
                options={VariantList}
                selectedValues={VariantName}
                onChange={setVariantName}
                onLoad={loadGridData}
              />
            </div>

            <div className="form-column"></div>
          </div>

          {/* ---------------- TABLE ---------------- */}
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>S.N</th>
                  <th>Variant</th>
                  <th>FSC</th>
                  <th>VIN</th>
                  <th>Fuel</th>
                  <th>Consumer Support</th>
                  <th>Company</th>
                  <th>Dealer</th>
                  <th>Exchange Amount</th>
                  <th>Company</th>
                  <th>Dealer</th>
                  <th>Corporate Amount</th>
                  <th>Company</th>
                  <th>Dealer</th>
                  <th>Mfg Year AMT</th>
                  <th>Company</th>
                  <th>Dealer</th>
                  <th>Dealer Discount</th>
                  <th>Company</th>
                  <th>Dealer</th>
                  <th>Additional Discount</th>
                  <th>Company</th>
                  <th>Dealer</th>
                  <th style={{ display: "none" }}>Unq</th>
                  <th style={{ display: "none" }}>ModelUnq</th>
                  <th style={{ display: "none" }}>varunq</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {gridRows.map((row, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    {/* Generate all visible columns */}
                    {Object.keys(row).map((col, idx) =>
                      col !== "variant" &&
                      col !== "unq" &&
                      col !== "modelunq" &&
                      col !== "varunq" ? (
                        <td key={idx}>
                          <input
                            className="grid-input"
                            value={row[col]}
                            onChange={(e) =>
                              handleGridChange(index, col, e.target.value)
                            }
                          />
                        </td>
                      ) : col === "variant" ? (
                        <td key={idx}>
                          <input
                            className="grid-input"
                            value={row.variant}
                            onChange={(e) =>
                              handleGridChange(index, "variant", e.target.value)
                            }
                          />
                        </td>
                      ) : null,
                    )}
                    {/* ADD HIDDEN CELLS HERE */}
                    <td style={{ display: "none" }}>
                      <input
                        value={row.unq}
                        onChange={(e) =>
                          handleGridChange(index, "unq", e.target.value)
                        }
                      />
                    </td>

                    <td style={{ display: "none" }}>
                      <input
                        value={row.modelunq}
                        onChange={(e) =>
                          handleGridChange(index, "modelunq", e.target.value)
                        }
                      />
                    </td>
                    <td style={{ display: "none" }}>
                      <input
                        value={row.varunq}
                        onChange={(e) =>
                          handleGridChange(index, "varunq", e.target.value)
                        }
                      />
                    </td>
                    {/* ACTION BUTTON */}
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() =>
                          setGridRows(gridRows.filter((_, i) => i !== index))
                        }
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ---------------- BUTTONS ---------------- */}
          <div style={buttonContainerStyle}>
            {!isEditing && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {isEditing && (
              <button
                style={buttonStyle("#2e20abff")}
                type="button"
                onClick={handleUpdate}
              >
                Update
              </button>
            )}
            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------
            CSS EXACTLY LIKE INSURANCE MASTER / RATE MASTER
      ---------------------------------------------------- */}
      <style>
        {`
      .rs__menu-portal {
  z-index: 9999 !important;
}

/* ===== PAGE ===== */
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
}

.container {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.08);
}

/* ===== HEADER ===== */
.header {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ===== FORM GRID ===== */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

/* Inputs + react-select look same */
input,
select {
  height: 40px !important;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
  box-sizing: border-box;
}

/* ===== TABLE ===== */
.table-container {
  overflow-x: auto;
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
}

th {
  background: #f8bcbc;
  padding: 10px;
  border: 1px solid #ccc;
  text-align: center;
  white-space: nowrap;
  position: sticky;
  top: 0;
}

td {
  border: 1px solid #ccc;
  padding: 6px;
  min-width: 110px;
  text-align: center;
}

/* Grid inputs */
.grid-input {
  width: 100%;
  height: 32px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
}

.grid-input:focus {
  outline: none;
  background: #fff3cd;
}

/* Delete button (clean) */
.delete-btn {
  background: #d32f2f;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

/* ===== BUTTONS ===== */
.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 22px;
  flex-wrap: wrap;
}

.btn-save {
  background: #4caf50;
  color: #fff;
  padding: 12px 28px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

.btn-exit {
  background: #ab2025;
  color: #fff;
  padding: 12px 28px;
  border-radius: 6px;
  border: none;
  font-weight: 600;
  cursor: pointer;
}

/* ===== RESPONSIVE ===== */

/* Laptop */
@media (max-width: 1200px) {
  .form-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Tablet */
@media (max-width: 992px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .button-container {
    flex-direction: row;
  }

  .button-container button {
    flex: 1;
  }
}

`}
      </style>
    </Layout>
  );
};

export default SchemeMasterDetailsDesign;
